export default [
    {
        path: '/validasi-keberadaan',
        redirect: '/validasi-keberadaan',
        name: 'validasiKeberadaan',
        component: () => import('@/views/NestedRoute.vue'),
        children: [
            {
                path: '',
                name: 'validasiKeberadaanIndex',
                component: () => import('@/views/validasiKeberadaan/Index.vue'),
                meta: {
                    action: 'Lihat',
                    resource: 'validasiKeberadaan',
                    pageTitle: 'Validasi Keberadaan',
                    breadcrumb: [
                        {
                            text: 'Validasi Keberadaan',
                            active: true,
                        },
                    ],
                },
            },
            {
                path: '/validasi-keberadaan/validasi/:id',
                name: 'validasiKeberadaanValidasi',
                component: () => import('@/views/validasiKeberadaan/Validasi.vue'),
                meta: {
                    action: 'Validasi',
                    resource: 'validasiKeberadaan',
                    pageTitle: 'KIB A/C/D - Keberadaan BMD',
                    breadcrumb: [
                        {
                            text: 'Validasi Keberadaan',
                        },
                        {
                            text: 'Validasi',
                            active: true,
                        },
                    ],
                },
                props: true
            },
            {
                path: '/validasi-keberadaan/detail/:id',
                name: 'validasiKeberadaanDetail',
                component: () => import('@/views/validasiKeberadaan/Validasi.vue'),
                meta: {
                    action: 'Detail',
                    resource: 'validasiKeberadaan',
                    pageTitle: 'KIB A/C/D - Keberadaan BMD',
                    breadcrumb: [
                        {
                            text: 'Validasi Keberadaan',
                        },
                        {
                            text: 'Validasi',
                            active: true,
                        },
                    ],
                },
                props: true
            },
        ]
    }
]